import * as React from 'react'
import { ReactElement } from 'react'
import { Route, RouteComponentProps } from 'react-router'
import GlobalTaskOverview from './Task/GlobalTaskOverview'
import TaskOverview from './Task/TaskOverview'
import EntityPage, { EntityPageProps, ParentProps } from './EntityPage'

export const taskBaseUrl = '/task'

/**
 * Adding and editing a task happens in a dialog on top of the overview (HAM-4275), so `/task/add` and
 * `/task/<id>/edit` render the overview as well; BaseMutableOverview opens the dialog from the route parameters.
 * The edit url keeps its original shape so links from before this change - the one in the "e-mail about task" body,
 * among others - keep working.
 */
export default function Tasks(props: EntityPageProps): ReactElement {
    return (
        <EntityPage {...props} baseUrl={taskBaseUrl}>
            {({ route, baseUrl }: ParentProps) => (
                <Route
                    path={[`${route}/:id/:action(edit)`, `${route}/:action(add)`, route]}
                    render={(routeProps: RouteComponentProps) =>
                        props.currentFile === undefined && props.currentCRMRelation === undefined ? (
                            <GlobalTaskOverview baseUrl={baseUrl} />
                        ) : (
                            <TaskOverview
                                {...routeProps}
                                {...props}
                                fileId={props.currentFile?.id}
                                crmRelationId={props.currentCRMRelation?.id}
                                baseUrl={baseUrl}
                                localStorageKeyPrefix={`HammockTaskOverview-${props.currentFile?.id || props.currentCRMRelation?.id}-`}
                            />
                        )
                    }
                />
            )}
        </EntityPage>
    )
}
